import PropTypes from 'prop-types';
// @mui
import {
    Box,
    Radio,
    Stack,
    Button,
    Drawer,
    Rating,
    Divider,
    Checkbox,
    FormGroup,
    IconButton,
    Typography,
    FormControlLabel,
    FormControl,
    Tab,
    tabsClasses,
    Grid,
} from '@mui/material';
import Scrollbar from '../scrollbar/Scrollbar';
import Iconify from '../iconify/Iconify';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList, session } from 'src/utils';
import React from 'react';
import { useParams } from 'react-router-dom';
import { TabContext, TabList, TabPanel } from '@mui/lab';
// components

// ----------------------------------------------------------------------

export const SORT_BY_OPTIONS = [
    { value: 'featured', label: 'Featured' },
    { value: 'newest', label: 'Newest' },
    { value: 'priceDesc', label: 'Price: High-Low' },
    { value: 'priceAsc', label: 'Price: Low-High' },
];
export const FILTER_GENDER_OPTIONS = ['Men', 'Women', 'Kids'];
export const FILTER_CATEGORY_OPTIONS = ['All', 'Shose', 'Apparel', 'Accessories'];
export const FILTER_RATING_OPTIONS = ['up4Star', 'up3Star', 'up2Star', 'up1Star'];
export const FILTER_PRICE_OPTIONS = [
    { value: 'below', label: 'Below $25' },
    { value: 'between', label: 'Between $25 - $75' },
    { value: 'above', label: 'Above $75' },
];
export const FILTER_COLOR_OPTIONS = [
    '#00AB55',
    '#000000',
    '#FFFFFF',
    '#FFC0CB',
    '#FF4842',
    '#1890FF',
    '#94D82D',
    '#FFC107',
];

// ----------------------------------------------------------------------

ProductFilterSidebar.propTypes = {
    openFilter: PropTypes.bool,
    onOpenFilter: PropTypes.func,
    onCloseFilter: PropTypes.func,
};

export default function ProductFilterSidebar({ openFilter, onOpenFilter, onCloseFilter, getValue, valueChange = [], idGroup = undefined }) {
    const getRef = React.useRef(false);

    const params = useParams();
    const [arrFillters, setArrFillters] = React.useState([]);
    const [property, setProperty] = React.useState([]);

    const [value, setValue] = React.useState('');

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    React.useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    // alert(params.idGroup);

    React.useEffect(() => {
        valueChange.length > 0 && setProperty(valueChange);
    }, [valueChange]);

    const getData = React.useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [+params.idGroup || +idGroup];
        sendRequest(serviceList.getIDgroup_devices, InVal, getDataResult, true, timeOutFunctget, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1[0].group_properties;
            if (data?.length > 0) {
                const transformedData = data.map((item) => {
                    const newValue = item.value.map((valueItem) => {
                        return Object.assign({}, { label: valueItem, value: valueItem, checked: false });
                    });

                    return Object.assign({}, item, { value: newValue });
                });
                // const newArray = data.map((item) => {
                //     return item.value.map((value) => {
                //         return { label: value, value: value };
                //     });
                // });
                setProperty(transformedData);
                setValue(glb_sv.convertMultipleLanguages(transformedData[0].label));
            }
        }
    };

    const timeOutFunctget = (reqInfo) => {
        getRef.current = false;
    };
    const handleChange = (e, data, index) => {
        if (e.target.checked) {
            setArrFillters([...arrFillters, { ...data, checked: true }]);
        } else {
            setArrFillters([...arrFillters, { ...data, checked: false }]);
            getValue && getValue([...arrFillters]);
        }
    };
    const handleClick = (item, index, indexParent) => {
        if (item) {
            property[indexParent].value[index] = { ...property[indexParent].value[index], checked: !item.checked };
            setProperty([...property]);
        }
    };

    return (
        <>
            <Button
                disableRipple
                color="inherit"
                endIcon={<Iconify icon="ic:round-filter-list" />}
                onClick={onOpenFilter}
            >
                {t('bo_loc')}&nbsp;
            </Button>

            <Drawer
                anchor="right"
                open={openFilter}
                onClose={onCloseFilter}
                PaperProps={{
                    sx: { width: 550, border: 'none', overflow: 'hidden' },
                }}
            >
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1, py: 2 }}>
                    <Typography variant="subtitle1" sx={{ ml: 1 }}>
                        {t('property')}
                    </Typography>
                    <IconButton onClick={onCloseFilter}>
                        <Iconify icon="eva:close-fill" />
                    </IconButton>
                </Stack>

                <Divider />

                {/* <Scrollbar> */}
                <Stack sx={{ maxHeight: '100%', overflowY: 'scroll' }} className="srcoll-test">
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList
                                    value={value}
                                    onChange={handleChangeTab}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    aria-label="scrollable auto tabs example"
                                    sx={{
                                        [`& .${tabsClasses.scrollButtons}`]: {
                                            '&.Mui-disabled': { opacity: 0.3 },
                                        },
                                    }}
                                >
                                    {property.length > 0 &&
                                        property.map((item, index) => (
                                            <Tab
                                                key={index}
                                                label={glb_sv.convertMultipleLanguages(item.label)}
                                                value={glb_sv.convertMultipleLanguages(item.label)}
                                            />
                                        ))}
                                </TabList>
                            </Box>
                            {property.length > 0 &&
                                property.map((item, index) => (
                                    <TabPanel key={index} value={glb_sv.convertMultipleLanguages(item.label)}>
                                        <div key={index}>
                                            <FormControl>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {glb_sv.convertMultipleLanguages(item.label)}
                                                </Typography>
                                                <FormGroup>
                                                    <Grid container spacing={1}>
                                                        {item?.value?.length > 0 &&
                                                            item.value.map((value, idx) => (
                                                                <Grid item key={idx} xs={4} width={500}>
                                                                    <FormControlLabel
                                                                        name={item.id}
                                                                        control={
                                                                            <Checkbox
                                                                                onClick={() =>
                                                                                    handleClick(value, idx, index)
                                                                                }
                                                                                checked={value.checked}
                                                                                label={glb_sv.convertMultipleLanguages(
                                                                                    value.label
                                                                                )}
                                                                                value={value.value}
                                                                            />
                                                                        }
                                                                        checked={value.checked}
                                                                        label={glb_sv.convertMultipleLanguages(
                                                                            value.label
                                                                        )}
                                                                        value={value.value}
                                                                    />
                                                                </Grid>
                                                            ))}
                                                    </Grid>
                                                </FormGroup>
                                            </FormControl>
                                        </div>
                                    </TabPanel>
                                ))}
                        </TabContext>
                    </Box>
                </Stack>
                {/* </Scrollbar> */}

                {/* <Scrollbar> */}
                {/* <Stack spacing={3} sx={{ p: 3, maxHeight: '100%', overflowY: 'scroll' }} className="srcoll-test">
                    {property.length > 0 &&
                        property.map((item, index) => (
                            <div key={index}>
                                <FormControl>
                                    <Typography variant="subtitle1" gutterBottom>
                                        // {item.label}
                                        {glb_sv.convertMultipleLanguages(item.label)}
                                    </Typography>
                                    <FormGroup>
                                        {item?.value?.length > 0 &&
                                            item.value.map((value, idx) => (
                                                <FormControlLabel
                                                    key={idx}
                                                    name={item.id}
                                                    control={
                                                        <Checkbox
                                                            onClick={() => handleClick(value, idx, index)}
                                                            checked={value.checked}
                                                            label={glb_sv.convertMultipleLanguages(value.label)}
                                                            value={value.value}
                                                        />
                                                    }
                                                    checked={value.checked}
                                                    label={glb_sv.convertMultipleLanguages(value.label)}
                                                    value={value.value}
                                                />
                                            ))}
                                    </FormGroup>
                                </FormControl>
                            </div>
                        ))}
                </Stack> */}
                {/* </Scrollbar> */}

                <Box sx={{ p: 3 }}>
                    <Button
                        fullWidth
                        onClick={() => {
                            onCloseFilter();
                            getValue && getValue([...property]);
                        }}
                        size="large"
                        type="submit"
                        color="primary"
                        variant="outlined"
                        startIcon={<Iconify icon="ic:round-filter-list" />}
                    >
                        {t('filter')}
                    </Button>
                </Box>
            </Drawer>
        </>
    );
}
